module.exports = __webpack_public_path__ + "img/kcbz.c68c9f60.png";